import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import EvaluateAbilitiesIntro from './EvaluateAbilitiesIntro';
import EvaluateAbilitiesPhysical from './EvaluateAbilitiesPhysical';
import EvaluateAbilitiesVisual from './EvaluateAbilitiesVisual';
import EvaluateAbilitiesCognition from './EvaluateAbilitiesCognition';
import EvaluateAbilitiesOther from './EvaluateAbilitiesOther';
import EvaluateAbilitiesReview from './EvaluateAbilitiesReview';
import { TABS, SUBTABS } from './ConstPaths';

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  bodySites: PropTypes.arrayOf(PropTypes.string),
  bodySiteComments: PropTypes.string,
  wearsGlasses: PropTypes.string,
  betterWithGlasses: PropTypes.string,
  hasOtherVisualAids: PropTypes.string,
  visualAidsNotes: PropTypes.string,
  formalEvalNotes: PropTypes.string,
  visionIssues: PropTypes.arrayOf(PropTypes.string),
  issuesNotes: PropTypes.string,
  strengths: PropTypes.string,
  limitations: PropTypes.string,
  otherIssues: PropTypes.string,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  bodySites: [],
  bodySiteComments: '',
  wearsGlasses: '',
  betterWithGlasses: '',
  hasOtherVisualAids: '',
  visualAidsNotes: '',
  formalEvalNotes: '',
  visionIssues: [],
  issuesNotes: '',
  strengths: '',
  limitations: '',
  otherIssues: ''
};

//when the url matches '/evaluate-abilities' this component renders
function EvaluateAbilities(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  //props for physical section
  const bodySites = props.bodySites;
  const bodySiteComments = props.bodySiteComments;
  //props for visual section
  const wearsGlasses = props.wearsGlasses;
  const betterWithGlasses = props.betterWithGlasses;
  const hasOtherVisualAids = props.hasOtherVisualAids;
  const visualAidsNotes = props.visualAidsNotes;
  const formalEvalNotes = props.formalEvalNotes;
  const visionIssues = props.visionIssues;
  const issuesNotes = props.issuesNotes;
  //props for language-cognition section
  const strengths = props.strengths;
  const limitations = props.limitations;
  //props for other characteristics section
  const otherIssues = props.otherIssues;

  const updateSession = props.updateSession;
  const {search} = useLocation();

  console.log("rendering EvaluateAbilities, bodySites: " + bodySites);

  return(
    <>
    <Switch>
      <Route path={SUBTABS.EVAL_INTRO}>
        <EvaluateAbilitiesIntro firstName={firstName}/> 
      </Route>
      <Route path={[SUBTABS.PHYSICAL + "/:step", SUBTABS.PHYSICAL]}>
        <EvaluateAbilitiesPhysical 
          firstName={firstName} 
          pronouns={pronouns}
          bodySites={bodySites}
          bodySiteComments={bodySiteComments}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.VISUAL + "/:step", SUBTABS.VISUAL]}>
        <EvaluateAbilitiesVisual 
          firstName={firstName} 
          pronouns={pronouns}
          wearsGlasses={wearsGlasses}
          betterWithGlasses={betterWithGlasses}
          hasOtherVisualAids={hasOtherVisualAids}
          visualAidsNotes={visualAidsNotes}
          formalEvalNotes={formalEvalNotes}
          visionIssues={visionIssues}
          issuesNotes={issuesNotes}
          updateSession={updateSession}
        /> 
      </Route>
      <Route path={[SUBTABS.COGNITION + "/:step", SUBTABS.COGNITION]}>
        <EvaluateAbilitiesCognition
          firstName={firstName} 
          pronouns={pronouns}
          strengths={strengths}
          limitations={limitations}
          updateSession={updateSession}
        />
      </Route>      
      <Route path={[SUBTABS.OTHER + "/:step", SUBTABS.OTHER]}>
        <EvaluateAbilitiesOther
          firstName={firstName} 
          pronouns={pronouns}
          otherIssues={otherIssues}
          updateSession={updateSession}
        />
      </Route>      
      <Route path={[SUBTABS.EVAL_REVIEW]}>
        <EvaluateAbilitiesReview
          firstName={firstName}
          pronouns={pronouns} 
          bodySites={bodySites}
          bodySiteComments={bodySiteComments}
          wearsGlasses={wearsGlasses}
          betterWithGlasses={betterWithGlasses}
          hasOtherVisualAids={hasOtherVisualAids}
          visualAidsNotes={visualAidsNotes}
          formalEvalNotes={formalEvalNotes}
          visionIssues={visionIssues}
          issuesNotes={issuesNotes}
          strengths={strengths}
          limitations={limitations}
          otherIssues={otherIssues}
       /> 
      </Route>

      {/* if path is exactly '/evaluate-abilities', go to 'evaluate-abilities/intro' */}
      <Route exact path={TABS.EVAL}>
        <Redirect to={SUBTABS.EVAL_INTRO + search} />
      </Route>  
    </Switch>
    </>
  );
}

EvaluateAbilities.propTypes = propTypes;
EvaluateAbilities.defaultProps = defaultProps;

export default EvaluateAbilities;
